import { Dropdown } from '@/design-system';

import { reportCopy } from '../copy';

export interface ReportMoreItem<T extends string> {
    value: T;
    label: string;
    /** Waarom het nu niet kan; staat als tweede regel onder het label. */
    hint?: string;
    disabled?: boolean;
    onSelect: () => void;
}

export interface ReportMoreMenuProps<T extends string> {
    items: readonly ReportMoreItem<T>[];
}

/**
 * "Meer" in de kop van het rapport: wat je af en toe nodig hebt, maar wat de
 * hoofdactie niet in de weg mag staan - het rapport lezen zoals de koper het ziet,
 * de PDF bekijken of downloaden, en de klantpagina.
 *
 * Het is de `Dropdown` uit het design system, zonder gekozen waarde: hij toont
 * altijd "Meer", en een keuze voert de actie uit in plaats van iets te onthouden.
 * Toetsenbord en schermlezer werken dus zoals bij elke andere keuzelijst.
 */
export function ReportMoreMenu<T extends string>({ items }: ReportMoreMenuProps<T>) {
    return (
        <Dropdown<T | ''>
            aria-label={reportCopy.more}
            value=""
            placeholder={reportCopy.more}
            surface="onDark"
            size="sm"
            align="end"
            options={items.map(({ value, label, hint, disabled }) => ({
                value,
                label,
                hint,
                disabled,
            }))}
            onChange={(value) => items.find((item) => item.value === value)?.onSelect()}
            /*
             * Zonder gekozen waarde kleurt de Dropdown zijn tekst als een placeholder. "Meer"
             * is hier geen placeholder maar het label van een knop: dezelfde kleur en
             * hoogte als de knoppen ernaast (`Button variant="onDark" size="sm"`).
             */
            className="min-h-[40px] [&_span]:text-[var(--text-on-dark-2)]"
        />
    );
}
